export const CouponsDB = [
  {
    id: 1,
    percentage: 75,
    minPurchase: 1200,
    code: "FOOTWEAR4U",
    expiry: "MAY 31 2021",
    details: "Rs. 300 off on minimum purchase of Rs. 1200",
    used: false
  },
  {
    id: 2,
    percentage: 70,
    minPurchase: 1000,
    code: "WFEXTRA150",
    expiry: "MAY 31 2021",
    details: "Rs. 150 off on minimum purchase of Rs. 1000",
    used: false
  },
  {
    id: 3,
    percentage: 65,
    minPurchase: 1500,
    code: "PUMAEXTRA100",
    expiry: "MAY 31 2021",
    details: "Rs. 100 off on minimum purchase of Rs. 1500",
    used: false
  }
];
